import { Card, Pagination, Table } from 'antd';
import { ICouponAttributes } from 'interfaces/coupon.interface';
import { useCallback } from 'react';
import { SanitizeHtml } from 'ui/components/MaiNguyen/SanitizeHtml';
import { useFetchTopCouponsUsed } from '../../hook';
import Title from '../Title';

const TopCouponsUsed: React.FC = () => {
  // Hook get top coupons used
  const { isFetching, data, pagination, setPagination, fetchTopCouponsUsed } =
    useFetchTopCouponsUsed();

  /**
   * Handle the product list of changing the current page in pagination.
   *
   * @param {number} page - The new page number.
   * @returns {Promise<void>} - A Promise that doesn't return a value.
   */
  const onPageChange = useCallback(
    async (page: number) => {
      setPagination((prev) => ({ ...prev, current: page }));
      await fetchTopCouponsUsed({ page });
    },
    [fetchTopCouponsUsed],
  );

  // table
  const columns = [
    {
      title: 'STT',
      dataIndex: '',
      width: 40,
      render: (_, __, index: number) => '#' + Number(index + 1),
    },
    {
      title: 'Tên chương trình',
      dataIndex: 'attributes',
      render: (attr: ICouponAttributes) => {
        return (
          <>
            <SanitizeHtml rawHtml={attr.title} className="product-name" title={attr.title} />
            <SanitizeHtml rawHtml={attr.displayTitle} className="desc" title={attr.displayTitle} />
          </>
        );
      },
    },
    {
      title: 'Lượt dùng',
      dataIndex: 'attributes',
      className: 'text-center',
      width: 100,
      render: (attr: ICouponAttributes) => <div className="text-center">{`${attr.count}`}</div>,
    },
  ];

  return (
    <Card className="dashboard-card">
      <div className="top-product-list">
        <div>
          <div className="dashboard-header mb-2">
            <Title text="Chương trình COUPON được dùng nhiều nhất" />
          </div>

          <Table
            columns={columns}
            dataSource={data}
            rowKey="id"
            loading={isFetching}
            pagination={false}
          />
        </div>

        {!!data?.length && (
          <div className="text-right">
            <Pagination
              {...pagination}
              pageSizeOptions={[]}
              onChange={onPageChange}
              disabled={isFetching}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default TopCouponsUsed;
